<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      class="custom-drawer"
      width="18.75rem"
      color="gray2"
      height="100%"
      dark
      app
    >
      <div class="d-flex align-center px-4 py-2">
        <v-menu
          v-model="statusMenu"
          ref="statusMenu"
          content-class="mt-2"
          min-width="12.5rem"
          :disabled="user.settings.attendancesNotification === false"
          :close-on-content-click="true"
          offset-y
        >
          <template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
            <v-badge
              bordered
              offset-x="30"
              offset-y="8"
              :color="_currentStatus?.color"
              bottom
              dot
            >
              <v-tooltip right>
                <template
                  v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }"
                >
                  <v-avatar
                    v-bind="{ ...menuAttrs, ...tooltipAttrs }"
                    v-on="{ ...menuOn, ...tooltipOn }"
                    class="mr-6"
                    size="2.5rem"
                    color="gray4"
                    rounded
                  >
                    <v-img v-if="user.photo" :src="user.photo" />
                    <v-icon v-else>mdi-account-outline</v-icon>
                  </v-avatar>
                </template>

                <span>
                  {{ _currentStatus?.label }}
                </span>
              </v-tooltip>
            </v-badge>
          </template>

          <v-list class="pt-0">
            <v-list-item>
              <v-list-item-title>Definir status</v-list-item-title>
            </v-list-item>

            <v-divider />

            <template v-for="(item, i) in _status">
              <v-list-item
                :key="i"
                :class="{ 'primary--text': user?.status === item.value }"
                :disabled="item.disabled"
                dense
                @click="changeStatus(item.value)"
                class="position-relative"
              >
                <v-list-item-icon class="mr-2">
                  <v-icon :color="item.color" x-small>mdi-circle</v-icon>
                </v-list-item-icon>

                <v-list-item-title
                  v-if="item.value === 'away'"
                  class="d-flex align-center justify-space-between"
                >
                  <span>{{ item.label }}</span>
                  <v-icon small>
                    {{ breakMenu ? "mdi-chevron-left" : "mdi-chevron-right" }}
                  </v-icon>
                </v-list-item-title>
                <v-list-item-title v-else>{{ item.label }}</v-list-item-title>

                <MenuPauses
                  v-if="item.value === 'away'"
                  v-model="breakMenu"
                  :pause-options="pauseOptions"
                  :disabled="!!currentPauseBody"
                  @select-option="selectBreak"
                />
              </v-list-item>
            </template>
          </v-list>
        </v-menu>

        <v-spacer />

        <v-btn class="custom-btn mr-2" small icon>
          <v-icon small @click="notificationBell">mdi-bell</v-icon>
        </v-btn>

        <v-menu
          content-class="mt-2"
          min-width="12.5rem"
          :close-on-content-click="false"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" class="custom-btn" small icon>
              <v-icon small>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item @click="handleDialog()">
              <v-list-item-icon class="mr-2">
                <v-icon small>mdi-account</v-icon>
              </v-list-item-icon>

              <v-list-item-title>Meu Perfil</v-list-item-title>
            </v-list-item>
            <v-list-item @click="signOut()">
              <v-list-item-icon class="mr-2">
                <v-icon small>mdi-logout</v-icon>
              </v-list-item-icon>

              <v-list-item-title>Sair</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <section class="d-flex flex-column pb-4">
        <div v-if="pauseStart && pauseEnd" class="py-1 px-2">
          <v-card
            :class="[
              'pause-card elevation-3',
              { 'pause-card--blinking': blinkState },
            ]"
            width="100%"
            dark
            flat
          >
            <!-- Card Header with Pause Name and Close Button -->
            <v-card-title class="py-1 px-3 position-relative">
              <div class="d-flex align-center pr-6 w-100 overflow-hidden">
                <v-icon
                  size="18"
                  class="mr-2 flex-shrink-0"
                  v-if="currentPauseBody && currentPauseBody.productive"
                  >mdi-clock-outline</v-icon
                >
                <v-icon size="18" class="mr-2 flex-shrink-0" v-else
                  >mdi-timer-off</v-icon
                >
                <span
                  class="text-caption font-weight-medium text-truncate"
                  v-if="currentPauseBody && currentPauseBody.name"
                >
                  {{ currentPauseBody.name }}
                </span>
              </div>

              <v-btn
                icon
                x-small
                class="pause-close-button"
                @click="handleCancelPause"
              >
                <v-icon size="16">mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-divider></v-divider>

            <!-- Card Content with Times -->
            <v-card-text class="py-2 px-3">
              <div class="d-flex justify-space-between">
                <!-- Start Time -->
                <div class="pause-card__time-block">
                  <div class="d-flex text-caption grey--text text--lighten-1">
                    Início:
                    <div
                      class="text-body-2 font-weight-medium white--text ml-2"
                    >
                      {{ pauseStart }}
                    </div>
                  </div>
                </div>

                <!-- End Time -->
                <div class="pause-card__time-block">
                  <div class="d-flex text-caption grey--text text--lighten-1">
                    Fim:
                    <div
                      class="text-body-2 font-weight-medium white--text ml-2"
                    >
                      {{ pauseEnd }}
                    </div>
                  </div>
                </div>
              </div>
            </v-card-text>

            <!-- Progress Indicator -->
            <v-progress-linear
              v-if="
                currentPauseBody &&
                currentPauseBody.duration &&
                pauseStartTimestamp
              "
              :value="progressPercentage"
              height="8"
              :color="blinkState ? 'error' : 'primary'"
              class="mt-0 mb-0"
            ></v-progress-linear>
          </v-card>
        </div>

        <v-divider class="gray1" />

        <template v-for="(item, i) in _routes">
          <div :key="i">
            <template v-if="item.section">
              <div v-if="item.permission">
                <v-divider class="mb-4 gray1" />

                <div
                  class="white--text text-subtitle-1 font-weight-bold ml-4 mb-4"
                >
                  {{ item.title }}
                </div>

                <div
                  v-for="(subitem, n) in item.routes"
                  :class="{ 'disabled-item': subitem.disabled }"
                  :key="`${i}-sub-${n}`"
                >
                  <div v-if="subitem.expandMode && subitem.permission">
                    <v-list-item
                      class="px-4"
                      :disabled="subitem.disabled"
                      @click="toggleExpand(subitem)"
                    >
                      <v-list-item-avatar
                        v-if="subitem.icon || subitem.svg"
                        rounded
                      >
                        <v-icon v-if="subitem.icon">
                          {{ subitem.icon }}
                        </v-icon>

                        <div v-else-if="subitem.svg" v-html="subitem.svg"></div>
                      </v-list-item-avatar>

                      <v-list-item-title class="gray6--text">
                        {{ subitem.label }}
                      </v-list-item-title>

                      <v-spacer />

                      <v-icon
                        small
                        :class="['chevron', { rotated: isExpanded(subitem) }]"
                      >
                        mdi-chevron-down
                      </v-icon>
                    </v-list-item>

                    <v-expand-transition>
                      <div
                        v-show="isExpanded(subitem)"
                        class="pl-10 pr-4 pb-2 pt-1"
                      >
                        <div
                          v-for="(child, c) in subitem.routes"
                          :key="`${i}-sub-${n}-child-${c}`"
                        >
                          <router-link
                            v-show="child.permission"
                            v-slot="{ href, navigate, isActive }"
                            :to="child.path"
                            custom
                          >
                            <v-list-item
                              class="px-4"
                              :class="isActive ? 'gray3' : 'transparent'"
                              :href="href"
                              :disabled="child.disabled"
                              @click="navigate"
                            >
                              <v-list-item-avatar
                                v-if="child.icon || child.svg"
                                rounded
                              >
                                <v-icon v-if="child.icon">
                                  {{ child.icon }}
                                </v-icon>

                                <div
                                  v-else-if="child.svg"
                                  v-html="child.svg"
                                ></div>
                              </v-list-item-avatar>

                              <v-list-item-title class="gray6--text">
                                {{ child.label }}
                              </v-list-item-title>
                            </v-list-item>
                          </router-link>
                        </div>
                      </div>
                    </v-expand-transition>
                  </div>

                  <div v-else>
                    <router-link
                      v-show="subitem.permission"
                      v-slot="{ href, navigate, isActive }"
                      :to="subitem.path"
                      :exact="subitem.exactAtive"
                      custom
                    >
                      <v-list-item
                        class="px-4"
                        :class="isActive ? 'gray3' : 'transparent'"
                        :href="href"
                        :disabled="subitem.disabled"
                        @click="navigate"
                      >
                        <v-list-item-avatar
                          v-if="subitem.icon || subitem.svg"
                          rounded
                        >
                          <v-icon v-if="subitem.icon">
                            {{ subitem.icon }}
                          </v-icon>

                          <div
                            v-else-if="subitem.svg"
                            v-html="subitem.svg"
                          ></div>
                        </v-list-item-avatar>

                        <v-list-item-title class="gray6--text">
                          {{ subitem.label }}
                        </v-list-item-title>
                      </v-list-item>
                    </router-link>
                  </div>
                </div>
              </div>
            </template>

            <div v-else :class="{ 'disabled-item': item.disabled }">
              <div v-if="item.expandMode && item.permission">
                <v-list-item
                  class="px-4"
                  :class="isExpanded(item) ? 'gray3' : 'transparent'"
                  :disabled="item.disabled"
                  @click="toggleExpand(item)"
                >
                  <v-list-item-avatar v-if="item.icon || item.svg" rounded>
                    <v-icon v-if="item.icon">
                      {{ item.icon }}
                    </v-icon>

                    <div v-else-if="item.svg" v-html="item.svg"></div>
                  </v-list-item-avatar>

                  <v-list-item-title class="gray6--text">
                    {{ item.label }}
                  </v-list-item-title>

                  <v-spacer />

                  <v-icon
                    small
                    :class="['chevron', { rotated: isExpanded(item) }]"
                  >
                    mdi-chevron-down
                  </v-icon>
                </v-list-item>

                <v-expand-transition>
                  <div v-show="isExpanded(item)" class="pl-10 pr-4 pb-2 pt-1">
                    <div
                      v-for="(subitem, n) in item.routes"
                      :key="`item-${i}-child-${n}`"
                      :class="{ 'disabled-item': subitem.disabled }"
                    >
                      <router-link
                        v-show="subitem.permission"
                        v-slot="{ href, navigate, isActive }"
                        :to="subitem.path"
                        custom
                      >
                        <v-list-item
                          class="px-4"
                          :class="isActive ? 'gray3' : 'transparent'"
                          :href="href"
                          :disabled="subitem.disabled"
                          @click="navigate"
                        >
                          <v-list-item-avatar
                            v-if="subitem.icon || subitem.svg"
                            rounded
                          >
                            <v-icon v-if="subitem.icon">
                              {{ subitem.icon }}
                            </v-icon>

                            <div
                              v-else-if="subitem.svg"
                              v-html="subitem.svg"
                            ></div>
                          </v-list-item-avatar>

                          <v-list-item-title class="gray6--text">
                            {{ subitem.label }}
                          </v-list-item-title>
                        </v-list-item>
                      </router-link>
                    </div>
                  </div>
                </v-expand-transition>
              </div>

              <div v-else>
                <router-link
                  v-show="item.permission"
                  v-slot="{ href, navigate, isActive }"
                  :to="item.path"
                  custom
                >
                  <v-list-item
                    class="px-4"
                    :class="isActive ? 'gray3' : 'transparent'"
                    :href="href"
                    :disabled="item.disabled"
                    @click="navigate"
                  >
                    <v-list-item-avatar v-if="item.icon || item.svg" rounded>
                      <v-icon v-if="item.icon">
                        {{ item.icon }}
                      </v-icon>

                      <div v-else-if="item.svg" v-html="item.svg"></div>
                    </v-list-item-avatar>

                    <v-list-item-title class="gray6--text">
                      {{ item.label }}
                    </v-list-item-title>
                  </v-list-item>
                </router-link>
              </div>
            </div>
          </div>
        </template>
      </section>

      <ProfileDialog
        ref="profileDialog"
        :loading="loading.user"
        @update="handleUpdateUser"
      />
    </v-navigation-drawer>
  </div>
</template>

<script>
import { getBreaks, stopBreak, getPeopleBreakByID } from "@/services/pauses";
import { updateUser } from "@/services/users";
import { handleAlert } from "@/utils";
import { mapActions, mapGetters, mapState } from "vuex";
import { eventBus } from "@/eventBus.js";
import MenuPauses from "./partials/menuPauses/MenuPauses.vue";
import ProfileDialog from "./partials/profileDialog/ProfileDialog.vue";

export default {
  name: "NavDrawer",

  components: {
    ProfileDialog,
    MenuPauses,
  },

  data() {
    return {
      drawer: true,
      loading: {
        user: false,
        breaks: false,
      },
      statusMenu: false,
      breakMenu: false,
      pauseOptions: [],
      selectedBreak: null,
      progressInterval: null,
      progressPercentage: 0,
      blinkState: false,
      expanded: {
        "expand:Fila de Atendimento": true,
        "expand:Relatórios": true,
      },
    };
  },

  created() {
    eventBus.$on("new-pause", this.getBreaks);
  },

  beforeMount() {
    this.getPeopleBreakByID();
  },

  mounted() {
    this.getBreaks();
  },

  beforeDestroy() {
    eventBus.$off("new-pause", this.getBreaks);

    clearInterval(this.progressInterval);
    this.progressInterval = null;
  },

  computed: {
    ...mapState([
      "user",
      "pauseStart",
      "pauseEnd",
      "currentPauseBody",
      "pauseStartTimestamp",
      "linkedAccess",
      "attendanceAccess",
      "audienceAccess",
    ]),
    ...mapGetters(["attendanceRole", "audienceRole"]),
    ...mapActions(["setSelectedCounters", "addSelectedCounter"]),

    _currentStatus() {
      const options = [
        {
          color: "green",
          value: "online",
          label: "Disponível",
        },
        {
          color: "red",
          value: "busy",
          label: "Ocupado",
        },
        ...this._status,
      ];

      const status = this.user.status || "online";
      const result = options.find((el) => el.value === status);
      return result ? result : options[0];
    },

    _routes() {
      return [
        {
          section: true,
          title: "Configuração",
          permission:
            this.$can("permission-groups") ||
            this.$can("breaks") ||
            this.$can("people"),
          routes: [
            {
              label: "Usuários",
              path: "/users",
              icon: "mdi-account-multiple-outline",
              permission: this.$can("people"),
              disabled:
                !this.linkedAccess &&
                !(
                  (this._isAdmin || this._isModerator) // admin e moderator podem acessar
                ),
            },
            {
              label: "Configurações",
              path: "/settings",
              icon: "mdi-cog-outline",
              permission: this.$can("permission-groups"),
              disabled: !this.linkedAccess, // regra default
            },
          ],
        },
        {
          section: true,
          title: "Módulo de atendimento",
          permission:
            this.$can("desks") ||
            this.$can("reports") ||
            this.$can("attendances") ||
            this.$can("appointments") ||
            this.$can("appointments.queue"),
          routes: [
            {
              label: "Visão Geral",
              path: "/home",
              icon: "mdi-view-dashboard",
              permission: true,
              disabled: !this.attendanceAccess, // regra default
            },
            {
              label: "Balcões",
              path: "/counters",
              icon: "mdi-view-day-outline",
              permission: this.$can("desks"),
              disabled:
                !this.attendanceAccess &&
                !(
                  this._isAdmin // somente admin pode acessar livremente
                ),
            },
            {
              label: "Pausas",
              path: "/pauses",
              icon: "mdi-pause-circle-outline",
              permission: this.$can("breaks"),
              disabled: !this.attendanceAccess, // regra default
            },
            {
              label: "Gestão de Pausas",
              path: "/pause-management",
              icon: "mdi-account",
              permission:
                this.$can("people-breaks") ||
                this.$can("people-breaks.history"),
              disabled: !this.attendanceAccess, // regra default
            },
            {
              label: "Comunicados",
              path: "/banners",
              icon: "mdi-bullhorn-outline",
              permission: this.$can("banners"),
              disabled: !this.linkedAccess, // regra default
            },
            {
              label: "Agendamentos",
              path: "/schedules",
              icon: "mdi-calendar-clock",
              permission: this.$can("appointments"),
              disabled:
                !this.attendanceAccess &&
                !(
                  this._isAdmin // somente admin pode acessar
                ),
            },
            {
              label: "Fila de Atendimento",
              expandMode: true,
              icon: "mdi-chart-box",
              permission:
                this.$can("attendances.queue") ||
                this.$can("appointments.queue"),
              disabled: !this.attendanceAccess, // regra default
              routes: [
                {
                  label: "Balcões",
                  path: "/omnichannel",
                  permission: this.$can("attendances.queue"),
                  disabled: !this.attendanceAccess, // regra default
                },
                {
                  label: "Gabinetes",
                  path: "/schedules-queue",
                  permission: this.$can("appointments.queue"),
                  disabled: !this.attendanceAccess, // regra default
                },
              ],
            },
            {
              label: "Relatórios",
              expandMode: true,
              icon: "mdi-chart-areaspline",
              permission:
                this.$can("reports.attendances") ||
                this.$can("reports.appointments"),
              disabled: !this.attendanceAccess, // regra default
              routes: [
                {
                  label: "Balcões",
                  path: "/reports",
                  permission: this.$can("reports.attendances"),
                  disabled: !this.attendanceAccess, // regra default
                },
                {
                  label: "Gabinetes",
                  path: "/schedules-reports",
                  permission: this.$can("reports.appointments"),
                  disabled: !this.attendanceAccess, // regra default
                },
              ],
            },
          ],
        },
        {
          section: true,
          title: "Módulo de audiência",
          permission: this.$can("audiences") || this.$can("entities"),
          routes: [
            {
              label: this.$t("entities"),
              path: "/entities",
              icon: "mdi-view-day-outline",
              permission: this.$can("entities"),
              disabled:
                !this.audienceAccess &&
                !(
                  this._isAudienceOperator // somente operator pode acessar livremente
                ),
            },
            {
              label: "Audiências",
              path: "/audiences",
              svg: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-gavel"><path d="m14.5 12.5-8 8a2.119 2.119 0 1 1-3-3l8-8"/><path d="m16 16 6-6"/><path d="m8 8 6-6"/><path d="m9 7 8 8"/><path d="m21 11-8-8"/></svg>`,
              permission: this.$can("audiences"),
              disabled: !this.audienceAccess, // regra default
            },
          ],
        },
      ];
    },

    _status() {
      return [
        ...(this.user.settings.attendancesNotification === undefined ||
        this.user.settings.attendancesNotification === true
          ? [
              {
                color: "amber",
                value: "away",
                label: "Ausente",
              },
            ]
          : []),
      ];
    },

    _rules() {
      return [(v) => !!v || "Campo obrigatório"];
    },

    _isOperator() {
      return this.attendanceRole === "operator";
    },

    _isModerator() {
      return this.attendanceRole === "moderator";
    },

    _isAdmin() {
      return this.attendanceRole === "admin";
    },

    _isSupervisor() {
      return this.attendanceRole === "supervisor";
    },

    _isAudienceAdmin() {
      return this.audienceRole === "admin";
    },

    _isAudienceOperator() {
      return this.audienceRole === "operator";
    },
  },

  watch: {
    selectedBreak(value) {
      this.$emit("change-status", value, "pause");
    },

    currentPauseBody: {
      immediate: true,
      handler(newValue) {
        if (this.pauseStart && newValue) {
          this.setupBlinkTimer();
        }
      },
    },

    blinkState(val) {
      if (val) this.startBlinkingAnimation();
    },
  },

  methods: {
    async getPeopleBreakByID(forceClose = false) {
      try {
        if (this.currentPauseBody?.pauseID) {
          const { data } = await getPeopleBreakByID(
            this.currentPauseBody.pauseID
          );

          if (data.finishedAt) this.clearPause();
          else if (forceClose) this.handleCancelPause();
          else this.setupBlinkTimer();
        }
      } catch (error) {
        handleAlert(error?.data?.message, "error");
      }
    },

    handlePauseDurationText(duration) {
      if (duration === 1) return `${duration}min`;
      return `${duration}mins`;
    },

    handlePauseData(data) {
      return data
        .filter((pause) => pause.active)
        .map((pause) => {
          return {
            ...pause,
          };
        });
    },

    clearPause() {
      this.$store.dispatch("setPauseTimes", { start: "", end: "" });

      this.selectedBreak = null;
      this.breakMenu = false;

      this.blinkState = false;
      this.progressPercentage = 0;
      clearInterval(this.progressInterval);
      this.progressInterval = null;

      this.$store.dispatch("setCurrentPauseBody", null);

      this.$emit("pause-cleared");
      eventBus.$emit("pause-cleared");
    },

    async handleCancelPause() {
      await this.$nextTick();

      if (this.currentPauseBody && this.currentPauseBody.pauseID) {
        try {
          const response = await stopBreak(this.currentPauseBody.pauseID);
          if (response) return this.clearPause();
        } catch (error) {
          console.error(error);
        }
      }
    },

    selectBreak(option) {
      this.blinkState = false;
      this.progressPercentage = 0;
      this.selectedBreak = option;

      this.$nextTick(() => {
        this.$refs.statusMenu.isActive = false;
      });
    },

    async getBreaks() {
      try {
        this.loading.breaks = true;

        const params = {
          limit: 100,
          offset: 0,
        };

        const { data } = await getBreaks(params);

        this.pauseOptions = this.handlePauseData(data);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading.breaks = false;
      }
    },

    changeStatus(value) {
      if (value === "away") {
        this.$emit("change-status", this.selectedBreak, value);
        this.breakMenu = false;

        return;
      }

      this.blinkState = false;
      this.progressPercentage = 0;
      clearInterval(this.progressInterval);
      this.progressInterval = null;

      this.$emit("change-status", value);
    },

    notificationBell() {
      this.$emit("notification-bell");
    },
    async handleUpdateUser(body) {
      if (this.user.status === "away") {
        await this.handleCancelPause();
      }

      this.loading.user = true;

      try {
        const payload = { ...body, status: "online" };
        const userID = payload._id || this.user._id;
        delete payload._id;

        await updateUser(userID, payload);
        this.$root.$emit("load-session");

        this.handleAlert("Perfil atualizado.", "success");
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.message ||
          "Erro ao atualizar perfil";
        this.handleAlert(message, "error");
      } finally {
        this.loading.user = false;
      }
    },

    setupBlinkTimer() {
      if (!this.currentPauseBody || !this.pauseStartTimestamp) return;

      const pauseDurationMs = this.currentPauseBody.duration * 60 * 1000;
      const blinkStartTime = this.pauseStartTimestamp + pauseDurationMs * 0.8;
      const now = Date.now();
      let timeUntilBlink = blinkStartTime - now;

      if (timeUntilBlink <= 0) {
        this.blinkState = true;
        this.progressPercentage = 100;
        clearInterval(this.progressInterval);
        this.progressInterval = null;

        return;
      }

      this.calculateProgressPercentage();
    },

    calculateProgressPercentage() {
      this.progressInterval = setInterval(() => {
        const pauseDurationMs =
          (this.currentPauseBody?.duration || 0) * 60 * 1000;
        const elapsedMs = Date.now() - this.pauseStartTimestamp;
        const percentage = Math.min(100, (elapsedMs / pauseDurationMs) * 100);

        this.progressPercentage = percentage;

        if (percentage >= 100) {
          this.blinkState = true;
          clearInterval(this.progressInterval);
          this.progressInterval = null;
        }
      }, 1000);
    },

    startBlinkingAnimation() {
      if (!this.blinkState) return;

      setTimeout(() => {
        if (this.blinkState) {
          const blinkingElement = document.querySelector(".pause-timer");

          if (blinkingElement) {
            blinkingElement.classList.toggle("pause-timer--blinking");
          }

          setTimeout(() => {
            if (this.pauseStart && this.pauseEnd && this.blinkState) {
              this.startBlinkingAnimation();
            }
          }, 800);
        }
      }, 800);
    },

    handleDrawer() {
      this.drawer = !this.drawer;
    },

    signOut() {
      this.$emit("sign-out");
    },

    handleDialog() {
      this.$refs.profileDialog.open();
    },

    getExpandKey(item) {
      return item.path ? `expand:${item.path}` : `expand:${item.label}`;
    },

    isExpanded(item) {
      const key = this.getExpandKey(item);
      return !!this.expanded[key];
    },

    toggleExpand(item) {
      const key = this.getExpandKey(item);
      this.$set(this.expanded, key, !this.expanded[key]);
    },

    handleAlert,
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
